import { createSlice } from '@reduxjs/toolkit';

import { clearState } from './clearSlice';

export const OUTBOX_STATUS = {
    QUEUED: 'queued',
    // The SDK holds the stanza in its own offline queue and sends it on reconnect.
    HANDED_OFF: 'handedOff',
    FAILED: 'failed',
};

// Delivery status stays on msgStatus; this only says a message never reached the server.
const initialState = {
    byMsgId: {},
};

const outboxSlice = createSlice({
    name: 'outbox',
    initialState,
    reducers: {
        setOutboxStatus(state, action) {
            const { msgId, status } = action.payload || {};
            if (msgId) state.byMsgId[msgId] = status;
        },
        setOutboxStatuses(state, action) {
            state.byMsgId = { ...state.byMsgId, ...action.payload };
        },
        removeFromOutbox(state, action) {
            delete state.byMsgId[action.payload];
        },
    },
    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { setOutboxStatus, setOutboxStatuses, removeFromOutbox } = outboxSlice.actions;

export const selectOutboxStatus = (state, msgId) => state.outbox.byMsgId[msgId];

export default outboxSlice.reducer;
